import { Spinner } from '@/components/ui/spinner';
import { api } from '@/lib/api';
import { enabledPageGuard } from '@/lib/migration';
import { permissaoGuard } from '@/lib/permissions';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import RelatoriosPageComponent from './-component';
import { searchSchema } from './-schemas';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/relatorios/',
)({
  validateSearch: searchSchema,
  search: {
    middlewares: [stripSearchParams(['page', 'q', 'tr'])],
  },
  loaderDeps({ search }) {
    return [search.pagina, search.filtro, search.relatorioId];
  },
  context: () => ({
    relatoriosQueryOptions: api.queryOptions(
      'get',
      '/relatorios',
      {},
      {
        // 10min
        staleTime: 1000 * 60 * 10,
      },
    ),
  }),
  beforeLoad: async () => {
    // No site antigo a página é 'relatorio', no singular.
    await enabledPageGuard('relatorios', {
      redirectToOldSitePage: 'comercial/produto/relatorio',
    });

    await permissaoGuard('Relatorios');
  },
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(context.relatoriosQueryOptions);
  },
  component: RouteComponent,
  pendingComponent: () => (
    <div className="flex size-full items-center justify-center">
      <Spinner className="size-6" />
    </div>
  ),
});

function RouteComponent() {
  return <RelatoriosPageComponent />;
}
